import React from "react"
import { postJson } from "../../helpers/http"
import { API_ENDPOINTS } from "../../helpers/api"
import SaveResourceModal from "./SaveResourceModal"
import { aiTierLabel } from "./AiPrompt"

const SaveFavoriteModal = ({ aiTier, prompt, useLocation, onClose }) => {
  const handleSave = async (name) => {
    const { error } = await postJson(API_ENDPOINTS.FAVORITES, {
      favorite: {
        name,
        ai_tier: aiTier,
        prompt: prompt || "",
        use_location: useLocation || false,
      },
    })
    return error
  }

  return (
    <SaveResourceModal title="Save to Account" defaultPrefix="Favorite" onSave={handleSave} onClose={onClose}>
      <div className="modal-preview">
        {prompt && (
          <div className="modal-preview-item">
            <span className="modal-preview-label">Prompt:</span>
            <span className="modal-preview-value modal-preview-prompt">{prompt}</span>
          </div>
        )}
        <div className="modal-preview-item">
          <span className="modal-preview-label">AI Tier:</span>
          <span className="modal-preview-value">{aiTierLabel(aiTier)}</span>
        </div>
        <div className="modal-preview-item">
          <span className="modal-preview-label">Precise Location:</span>
          <span className="modal-preview-value">{useLocation ? "On" : "Off"}</span>
        </div>
      </div>
    </SaveResourceModal>
  )
}

export default SaveFavoriteModal
